var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 59.326,
    height: 44.765,
    viewBox: "0 0 59.326 44.765",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_simple-gmail",
    "data-name": "Icon simple-gmail",
    d: "M59.326,8.23v37.3a3.653,3.653,0,0,1-3.708,3.73H51.91V15.41L29.663,31.483,7.416,15.41V49.265H3.708A3.651,3.651,0,0,1,0,45.534V8.23A3.72,3.72,0,0,1,1.065,5.574,3.661,3.661,0,0,1,3.708,4.5H4.944L29.663,22.53,54.382,4.5h1.236a3.655,3.655,0,0,1,3.708,3.73Z",
    transform: "translate(0 -4.5)",
    fill: "#001925"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.b655042954a6359e1572c2c8e25c7e8f.svg";
export { ForwardRef as ReactComponent };